import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectOption } from '@app/@shared/models/shared.models';

@Component({
  selector: 'app-sort-by',
  templateUrl: './sort-by.component.html',
  styleUrls: ['./sort-by.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class SortByComponent implements OnInit {
  @Input() selectedSort: SelectOption<string>;

  @Input() sortOptions: SelectOption<string>[] = [];

  @Output() sortChanged = new EventEmitter<SelectOption<string>>();

  isOpen = false;

  ngOnInit() {
    if(!this.selectedSort) {
      this.selectedSort = this.sortOptions[0];
    }
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  onSelect(option: SelectOption<string>): void {
    if (option.value === this.selectedSort?.value) {
      this.isOpen = false;
      return;
    }
    this.selectedSort = option;
    this.sortChanged.emit(option);
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: HTMLElement) {
    const clickedInside = target.closest('app-sort-by');
    if (!clickedInside) {
      this.isOpen = false;
    }
  }
}
